module.exports = __webpack_public_path__ + "static/media/28DGC8.bbae9b2b.jpg";